var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightningBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CFE7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 18L20.0933 28.6879C19.7445 29.1064 19.5701 29.3157 19.5674 29.4925C19.5651 29.6461 19.6336 29.7923 19.7531 29.8889C19.8906 30 20.163 30 20.7079 30H27.9999L26.9999 38L35.9064 27.3121C36.2552 26.8936 36.4296 26.6843 36.4323 26.5075C36.4346 26.3539 36.3661 26.2077 36.2466 26.1111C36.1091 26 35.8367 26 35.2918 26H27.9999L28.9999 18Z",
    stroke: "#0D67B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E2F1FD",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBolt);
export default __webpack_public_path__ + "static/media/lightning-bolt.33d9c1ca009250048404ebae1b7130c2.svg";
export { ForwardRef as ReactComponent };